import React, { Component } from 'react';
import VASSlider from 'react-surveyjs-vas-widget';
// import { Survey, CustomWidgetCollection } from 'survey-react';
import * as Survey from "survey-react";
import   SideNav from "./../../component/sidenav/sidenav.js"
import  Moble from "./../../component/sidenav/moble.js"
import _  from 'underscore';
import "survey-react/survey.css";
import "./message.css"

class  Message extends Component {


  constructor(props){
    super(props)
    this.state = {
        noerorrpage :  true,
        showM:false
     };
     
    
    }

    componentDidMount(){
        this.props.noerorrpage(this.state.noerorrpage)
    }

    showMessage=(e)=>{
        e.preventDefault()
       this.setState({
         showM : true
       })
    }

  render() {

    
    return (
                <div>
                    <div class="inbox-wrapper">
                                    <div class="wrapper-inner">
                                      
                                        <div class="inbox-sidebar">
                                         
                                            <div class="header-area">
                                                <h2 class="inbox-title">Inbox</h2>
                                                <div class="dropdown inbox-dropdown dropdown-trigger is-right">
                                                    <div>
                                                        <button class="button">
                                                            <span class="icon is-small">
                                                                <i class="sl sl-icon-options"></i>
                                                            </span>
                                                        </button>
                                                    </div>
                                                    <div class="dropdown-menu">
                                                        <div class="dropdown-content">
                                                            <a class="dropdown-item">
                                                                <i class="sl sl-icon-refresh"></i>
                                                                <span>Refresh</span>
                                                            </a>
                                                            <hr class="dropdown-divider"/>
                                                            <a class="dropdown-item">
                                                                <i class="sl sl-icon-bell"></i>
                                                                <span>Notifications</span>
                                                            </a>
                                                            <hr class="dropdown-divider"/>
                                                            <a class="dropdown-item">
                                                                <i class="sl sl-icon-people"></i>
                                                                <span>Invite People</span>
                                                            </a>
                                                            <hr class="dropdown-divider"/>
                                                            <a class="dropdown-item">
                                                                <i class="sl sl-icon-settings"></i>
                                                                <span>Settings</span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <a class="inbox-action inbox-close-sidebar-mobile">
                                                    <i class="material-icons">close</i>
                                                </a>
                                            </div>
                                            
                                            <div class="sidebar-inner">
                                         
                                                <div class="inner-menu">
                                                    <a class="button compose-button is-fullwidth">Compose</a>
                                                    <div class="inbox-menu">
                                                        <ul>
                                                            <li>
                                                                <a class="is-active">
                                                                    <i class="sl sl-icon-envelope-open"></i>
                                                                    <span>Inbox</span>
                                                                    <span class="tag">24</span>
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a>
                                                                    <i class="sl sl-icon-doc"></i>
                                                                    <span>Drafts</span>
                                                                    <span class="tag">2</span>
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a>
                                                                    <i class="sl sl-icon-paper-plane"></i>
                                                                    <span>Sent</span>
                                                                    <span class="tag">7</span>
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a>
                                                                    <i class="sl sl-icon-trash"></i>
                                                                    <span>Trash</span>
                                                                    <span class="tag">18</span>
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a>
                                                                    <i class="sl sl-icon-ban"></i>
                                                                    <span>Spam</span>
                                                                    <span class="tag">29</span>
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                {/* <!--Scroll menu--> */}
                                                <div class="scroll-menu">
                                                    <div class="title-wrap">
                                                        <h3>Contacts</h3>
                                                        <div class="control is-hidden">
                                                            <input type="text" class="input" placeholder="Search Contacts..."/>
                                                            <div class="form-icon">
                                                                <i class="sl sl-icon-magnifier"></i>
                                                            </div>
                                                        </div>
                                                        <a class="button search-button">
                                                            <i class="sl sl-icon-magnifier"></i>
                                                        </a>
                                                        <a class="button cancel-search-button is-hidden">
                                                            <i class="material-icons">close</i>
                                                        </a>
                                                    </div>
                                                    <div class="contact-list has-slimscroll">
                                                        {/* <!--Contact--> */}
                                                        <div class="contact-block">
                                                            <img src="assets/images/avatars/sally.jpg" data-demo-src="assets/images/avatars/sally.jpg" alt=""/>
                                                            <div class="contact-meta">
                                                                <span>Sally Jenkins</span>
                                                                <span>sallyj@gmail.com</span>
                                                            </div>
                                                        </div>
                                                      
                                                    </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
    
                                        {/* <!--Messages list--> */}
                                        <div class="inbox-messages">
                                            <div class="header-area">
                                                <div class="actions">
                                                    <a class="inbox-action mobile-menu-action">
                                                        <i class="material-icons">arrow_forward</i>
                                                    </a>
                                                    <a class="inbox-action check-all-action">
                                                        <i class="sl sl-icon-check"></i>
                                                    </a>
                                                </div>
                                                <div class="actions">
                                                    <div class="control inbox-search">
                                                        <input type="text" class="input is-rounded" placeholder="Search Inbox..."/>
                                                        <div class="form-icon">
                                                            <i class="sl sl-icon-magnifier"></i>
                                                        </div>
                                                    </div>
    
                                                    <div class="dropdown inbox-dropdown dropdown-trigger is-right">
                                                        <div>
                                                            <button class="button">
                                                                <span class="icon is-small">
                                                                    <i class="sl sl-icon-options"></i>
                                                                </span>
                                                            </button>
                                                        </div>
                                                        <div class="dropdown-menu">
                                                            <div class="dropdown-content">
                                                                <a class="dropdown-item">
                                                                    <i class="sl sl-icon-check"></i>
                                                                    <span>Mark all as read</span>
                                                                </a>
                                                                <hr class="dropdown-divider"/>
                                                                <a class="dropdown-item">
                                                                    <i class="sl sl-icon-ban"></i>
                                                                    <span>Hide read messages</span>
                                                                </a>
                                                                <hr class="dropdown-divider"/>
                                                                <a class="dropdown-item">
                                                                    <i class="sl sl-icon-clock"></i>
                                                                    <span>Sort by date</span>
                                                                </a>
                                                                <hr class="dropdown-divider"/>
                                                                <a class="dropdown-item">
                                                                    <i class="sl sl-icon-user"></i>
                                                                    <span>Sort by user</span>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <!--Messages--> */}
                                            <div class="messages-list has-slimscroll">
                                                {/* <!--messages list partial-->
                                                <!--Message--> */}
                                                <div class="inbox-message is-unread" data-message="message-2">
                                                    <div class="message-checkbox">
                                                        <div class="b-checkbox is-secondary">
                                                            <input id="checkbox-mail-1" class="styled styled-checkbox" type="checkbox"/>
                                                            <label for="checkbox-mail-1"></label>
                                                        </div>
                                                    </div>
                                                    <div class="message-meta">
                                                        <span class="name">Elie Daniels</span>
                                                        <span class="email">&lt;eliedaniels@bulkit.io&gt;</span>
                                                        <span class="subject"><b>I couldn't catch up on last time's dinner</b></span>
                                                    </div>
                                                    <div class="pushed">
                                                        Mar 03
                                                    </div>
                                                </div>
                                                {/* <!--Message--> */}
                                                
                                          
                                                {/* <!--Message--> */}
                                                <div class="inbox-message" data-message="message-8">
                                                    <div class="message-checkbox">
                                                        <div class="b-checkbox is-secondary">
                                                            <input id="checkbox-mail-8" class="styled styled-checkbox" type="checkbox"/>
                                                            <label for="checkbox-mail-8"></label>
                                                        </div>
                                                    </div>
                                                    <div class="message-meta">
                                                        <span class="name">Nathan Flick</span>
                                                        <span class="email">&lt;nathan@bulkit.io&gt;</span>
                                                        <span class="subject">Customer dashboard february bug report</span>
                                                    </div>
                                                    <div class="pushed">
                                                        Feb 18
                                                    </div>
                                                </div>
                                                {/* <!--Message--> */}
                                                <div class="inbox-message" data-message="message-9">
                                                    <div class="message-checkbox">
                                                        <div class="b-checkbox is-secondary">
                                                            {/* <input id="checkbox-mail-9" class="styled styled-checkbox" type="checkbox"> */}
                                                            <label for="checkbox-mail-9"></label>
                                                        </div>
                                                    </div>
                                                    <div class="message-meta">
                                                        <span class="name">Julia Schweitzel</span>
                                                        <span class="email">&lt;julia@bulkit.io&gt;</span>
                                                        <span class="subject">You didn't answer my last email !</span>
                                                    </div>
                                                    <div class="pushed">
                                                        Feb 18
                                                    </div>
                                                </div>
                                                {/* <!--Message--> */}
                                                <div class="inbox-message" data-message="message-10">
                                                    <div class="message-checkbox">
                                                        <div class="b-checkbox is-secondary">
                                                            <input id="checkbox-mail-10" class="styled styled-checkbox" type="checkbox"/>
                                                            <label for="checkbox-mail-10"></label>
                                                        </div>
                                                    </div>
                                                    <div class="message-meta">
                                                        <span class="name">Ray Stockton</span>
                                                        <span class="email">&lt;raystockton@gmail.com&gt;</span>
                                                        <span class="subject">Hop in for the next project review</span>
                                                    </div>
                                                    <div class="pushed">
                                                        Feb 17
                                                    </div>
                                                </div>                                        </div>
                                        </div>
    
                                        {/* <!--Loader--> */}
                                        <div class="inbox-message-overlay">
                                            <div class="loader is-loading"></div>
                                        </div>
    
                                        {/* <!--Message details 1-->
                                        <!-- Message details -->
                                         */}
                                        <div id="message-9" class="inbox-message-details is-hidden">
                                            <div class="header-area">
                                                <img class="sender-pic" src="assets/images/avatars/janet.jpg" data-demo-src="assets/images/avatars/janet.jpg" alt=""/>
                                                <div class="message-meta">
                                                    <span class="message-title">You didn't answer my last email !</span>
                                                    <span class="sender-email">&lt;julia@bulkit.io&gt;</span>
                                                </div>
                                                <div class="attachments is-vhidden inbox-hidden-mobile">
                                                    <i class="sl sl-icon-paper-clip"></i>
                                                    <span>0</span>
                                                </div>
                                                <div class="dropdown inbox-dropdown dropdown-trigger is-right">
                                                    <div>
                                                        <button class="button">
                                                            <span class="icon is-small">
                                                                <i class="sl sl-icon-options"></i>
                                                            </span>
                                                        </button>
                                                    </div>
                                                    <div class="dropdown-menu">
                                                        <div class="dropdown-content">
                                                            <a class="dropdown-item">
                                                                <i class="sl sl-icon-star"></i>
                                                                <span>Bookmark message</span>
                                                            </a>
                                                            <hr class="dropdown-divider"/>
                                                            <a class="dropdown-item">
                                                                <i class="sl sl-icon-share"></i>
                                                                <span>Share message</span>
                                                            </a>
                                                            <hr class="dropdown-divider"/>
                                                            <a class="dropdown-item">
                                                                <i class="sl sl-icon-shield"></i>
                                                                <span>Mark as spam</span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <a class="inbox-action inbox-close-details-mobile">
                                                    <i class="material-icons">close</i>
                                                </a>
                                            </div>
                                            {/* <!--Message--> */}
                                            <div class="message-wrapper has-slimscroll">
                                                <div class="message-inner">
                                                    <div class="message-head">
                                                        <div class="info">
                                                            <span>Sent on</span>
                                                            <span>Feb 18 2019, at 08:21am</span>
                                                        </div>
                                                        <div class="message-actions">
                                                            <a class="inbox-action">
                                                                <i class="sl sl-icon-action-undo"></i>
                                                            </a>
                                                            <a class="inbox-action">
                                                                <i class="sl sl-icon-docs"></i>
                                                            </a>
                                                            <a class="inbox-action">
                                                                <i class="sl sl-icon-tag"></i>
                                                            </a>
                                                            <a class="inbox-action">
                                                                <i class="sl sl-icon-bubble"></i>
                                                            </a>
                                                            <a class="inbox-action">
                                                                <i class="sl sl-icon-lock"></i>
                                                            </a>
                                                        </div>
                                                    </div>
                                                    {/* <!--Mail Content--> */}
                                                    <div class="mail-content content">
                                                        <p>Hi Mrs. Miller,</p>
                                                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nos commodius agimus. Si longus, levis; <a href="#" target="_blank">Summum ením bonum exposuit vacuitatem doloris;</a> Eadem
                                                            fortitudinis ratio reperietur. Duo Reges: constructio interrete. Facile est hoc cernere in primis
                                                            puerorum
                                                            aetatulis. </p>
                                                        <ul>
                                                            <li>Sed residamus, inquit, si placet.</li>
                                                            <li>Parvi enim primo ortu sic iacent, tamquam omnino sine animo sint.</li>
                                                            <li>Beatus autem esse in maximarum rerum timore nemo potest.</li>
                                                            <li>Illa argumenta propria videamus, cur omnia sint paria peccata.</li>
                                                        </ul>
                                        
                                                        <p>Julia</p>
                                                    </div>
                                                </div>
                                        
                                                {/* <!--Reply--> */}
                                                <div class="reply-box-wrap">
                                                    <div class="reply-bubble">
                                                        <div class="reply-as">
                                                            <img src="assets/images/avatars/helen.jpg" data-demo-src="assets/images/avatars/helen.jpg" alt=""/>
                                                            <div class="reply-details">
                                                                <span>Reply as</span>
                                                                <span>helenmiller@bulkit.io</span>
                                                            </div>
                                                            <div class="dropdown inbox-dropdown dropdown-trigger is-right">
                                                                <div>
                                                                    <button class="button">
                                                                        <span class="icon is-small">
                                                                            <i class="sl sl-icon-options"></i>
                                                                        </span>
                                                                    </button>
                                                                </div>
                                                                <div class="dropdown-menu">
                                                                    <div class="dropdown-content">
                                                                        <a class="dropdown-item">
                                                                            <i class="sl sl-icon-refresh"></i>
                                                                            <span>Reset</span>
                                                                        </a>
                                                                        <hr class="dropdown-divider"/>
                                                                        <a class="dropdown-item">
                                                                            <i class="sl sl-icon-book-open"></i>
                                                                            <span>Spelling</span>
                                                                        </a>
                                                                        <hr class="dropdown-divider"/>
                                                                        <a class="dropdown-item">
                                                                            <i class="sl sl-icon-mustache"></i>
                                                                            <span>Mention</span>
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* <!--textarea--> */}
                                                        <div class="control">
                                                            <textarea class="textarea" rows="6" placeholder="Type your message..."></textarea>
                                                            <button type="button" class="button">Send Message</button>
                                                        </div>
                                                    </div>
                                                </div>
                                        
                                            </div>
                                        </div>
                                        {/* <!--Message details 10-->
                                        <!-- Message details --> */}
                                        <div id="message-10" class="inbox-message-details is-hidden">
                                            <div class="header-area">
                                                <img class="sender-pic" src="assets/images/avatars/ray.jpg" data-demo-src="assets/images/avatars/ray.jpg" alt=""/>
                                                <div class="message-meta">
                                                    <span class="message-title">Hop in for the next project review</span>
                                                    <span class="sender-email">&lt;raystockton@gmail.com&gt;</span>
                                                </div>
                                                <div class="attachments inbox-hidden-mobile">
                                                    <i class="sl sl-icon-paper-clip"></i>
                                                    <span>1</span>
                                                </div>
                                                <div class="dropdown inbox-dropdown dropdown-trigger is-right">
                                                    <div>
                                                        <button class="button">
                                                            <span class="icon is-small">
                                                                <i class="sl sl-icon-options"></i>
                                                            </span>
                                                        </button>
                                                    </div>
                                                    <div class="dropdown-menu">
                                                        <div class="dropdown-content">
                                                            <a class="dropdown-item">
                                                                <i class="sl sl-icon-star"></i>
                                                                <span>Bookmark message</span>
                                                            </a>
                                                            <hr class="dropdown-divider"/>
                                                            <a class="dropdown-item">
                                                                <i class="sl sl-icon-share"></i>
                                                                <span>Share message</span>
                                                            </a>
                                                            <hr class="dropdown-divider"/>
                                                            <a class="dropdown-item">
                                                                <i class="sl sl-icon-shield"></i>
                                                                <span>Mark as spam</span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <a class="inbox-action inbox-close-details-mobile">
                                                    <i class="material-icons">close</i>
                                                </a>
                                            </div>
                                            {/* <!--Message--> */}
                                            <div class="message-wrapper has-slimscroll">
                                                <div class="message-inner">
                                                    <div class="message-head">
                                                        <div class="info">
                                                            <span>Sent on</span>
                                                            <span>Feb 17 2019, at 09:31am</span>
                                                        </div>
                                                        <div class="message-actions">
                                                            <a class="inbox-action">
                                                                <i class="sl sl-icon-action-undo"></i>
                                                            </a>
                                                            <a class="inbox-action">
                                                                <i class="sl sl-icon-docs"></i>
                                                            </a>
                                                            <a class="inbox-action">
                                                                <i class="sl sl-icon-tag"></i>
                                                            </a>
                                                            <a class="inbox-action">
                                                                <i class="sl sl-icon-bubble"></i>
                                                            </a>
                                                            <a class="inbox-action">
                                                                <i class="sl sl-icon-lock"></i>
                                                            </a>
                                                        </div>
                                                    </div>
                                                    {/* <!--Mail Content--> */}
                                                    <div class="mail-content content">
                                                        <p>Hi Helen,</p>
                                                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quid adiuvas? Dat enim intervalla et relaxat. Et nemo nimium
                                                            beatus est; Claudii libidini, qui tum erat summo ne imperio, dederetur. Duo Reges: constructio interrete. </p>
                                                        <p>Sedulo, inquam, faciam. Certe, nisi voluptatem tanti aestimaretis. <a href="http://loripsum.net/" target="_blank">Recte, inquit, intellegis.</a> Ergo, inquit, tibi Q. Recte, inquit, intellegis. </p>
                                                        <ul>
                                                            <li>Quid nunc honeste dicit?</li>
                                                            <li>Nos quidem Virtutes sic natae sumus, ut tibi serviremus, aliud negotii nihil habemus.</li>
                                                            <li>Negabat igitur ullam esse artem, quae ipsa a se proficisceretur;</li>
                                                        </ul>
                                                        <p>Satis est ad hoc responsum. Quod iam a me expectare noli. Confecta res esset. Bonum integritas corporis: misera
                                                            debilitas. Illum mallem levares, quo optimum atque humanissimum virum, Cn. Utrum igitur tibi litteram videor an
                                                            totas paginas commovere? </p>
                                                        <p>Ray</p>
                                                    </div>
                                        
                                                    {/* <!-- Attachments --> */}
                                                    <div class="attachments-list">
                                                        <div class="attachment">
                                                            <span>iteration-4.pdf</span>
                                                            <div class="download-icon">
                                                                <i class="material-icons">arrow_downward</i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                        
                                                {/* <!--Reply--> */}
                                                <div class="reply-box-wrap">
                                                    <div class="reply-bubble">
                                                        <div class="reply-as">
                                                            <img src="assets/images/avatars/helen.jpg" data-demo-src="assets/images/avatars/helen.jpg" alt=""/>
                                                            <div class="reply-details">
                                                                <span>Reply as</span>
                                                                <span>helenmiller@bulkit.io</span>
                                                            </div>
                                                            <div class="dropdown inbox-dropdown dropdown-trigger is-right">
                                                                <div>
                                                                    <button class="button">
                                                                        <span class="icon is-small">
                                                                            <i class="sl sl-icon-options"></i>
                                                                        </span>
                                                                    </button>
                                                                </div>
                                                                <div class="dropdown-menu">
                                                                    <div class="dropdown-content">
                                                                        <a class="dropdown-item">
                                                                            <i class="sl sl-icon-refresh"></i>
                                                                            <span>Reset</span>
                                                                        </a>
                                                                        <hr class="dropdown-divider"/>
                                                                        <a class="dropdown-item">
                                                                            <i class="sl sl-icon-book-open"></i>
                                                                            <span>Spelling</span>
                                                                        </a>
                                                                        <hr class="dropdown-divider"/>
                                                                        <a class="dropdown-item">
                                                                            <i class="sl sl-icon-mustache"></i>
                                                                            <span>Mention</span>
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* <!--textarea--> */}
                                                        <div class="control">
                                                            <textarea class="textarea" rows="6" placeholder="Type your message..."></textarea>
                                                            <button type="button" class="button">Send Message</button>
                                                        </div>
                                                    </div>
                                                </div>
                                        
                                            </div>
                                        </div>        
                                       
                                                        
                                </div>
                </div>
            )
        }
    }    
  export default  Message ;      






// WEBPACK FOOTER //
// ./src/component/company/message.js